"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCsmUsersApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.listCsmUsersApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('users'),
        attributes: zod_1.z.object({
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            email: zod_1.z.string(),
        }),
    })),
});
